'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeMe = undefined;

var _sizeMe = require('./sizeMe');

var _sizeMe2 = _interopRequireDefault(_sizeMe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.sizeMe = _sizeMe2.default;

// Backward compat

exports.default = _sizeMe2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-sizeme/commonjs/index.js
// module id = 422
// module chunks = 0